/* eslint-disable no-unused-vars */
import {
  Table,
  Thead,
  Tr,
  Td,
  Tbody,
  Button,
  ButtonGroup,
  Text,
  Flex,
  Box,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { ThStyledBlue } from "./Table.styled";
import { IconGeneric } from "styled/Icons.styled";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { BsFilter } from "react-icons/bs";

import "../SelectInput/stilos.css";
import { useQuery } from "@tanstack/react-query";
import { useGlobalContext } from "context/GlobalContext";
import environment from "constants/apiConst";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import { useNotations } from "context/NotationsContext";
import FormCrudCRUDContext from "context/FormCrudContex";
import Card from "../../DashBoard/Components/cards/Card";
import SpinnerComponent from "components/Spinner/SpinnerComponent";
import { AuthContext } from "context/AuthContext";
import InputSelect, { InputSelectMulti } from "components/InputSelect/InputSelect";
import queryEnv from "constants/queryConst";
import { useSelector } from "react-redux";
import { useSearchUrl } from "hooks/useSearchUrl";

const DashboardSimpleTable = () => {
  const { authUser } = useContext(AuthContext);
  const { freeZone_id } = useSelector((state) => state.auth.dataUser);

  const { state, handleSearchParams } = useSearchUrl({ 
    getParams: ["search", "valueQualified", "notificationType", "sortBy", "sortDirection"], 
    nestedProp: true ? "searchSimple" : null 
  })

  const [update, setUpdate] = useState(false);
  const [initialData, setInitialData] = useState([]);
  const [press, setPress] = useState("expiration_final_date"); // Por defecto ordenado por fecha de vencimiento
  const [sortDirection, setSortDirection] = useState("asc"); // Por defecto ascendente
  const [data, setData] = useState([]); // datos de la página actual
  const viewFilterQualified = false;

  const { requestData } = useGlobalContext();

  const [page, setPage] = useState(1);

  const [openAlert] = AlertErrorAlert();
  const { setDataCurrent } = useNotations();
  const [maxPage, setMaxPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [links, setLinks] = useState([]);

  const [userQualified, setUserQualified] = useState([]);

  // Tipos de notificación disponibles
  const notificationTypes = [
    { value: "", label: "Todos los tipos" },
    { value: "1", label: "Salidas Temporales por Vencer" },
    { value: "2", label: "Pases Ingresados por Vencer" },
    { value: "3", label: "Operaciones de ingreso 302" },
    { value: "4", label: "Perfilamiento de Formularios de ingreso" },
    { value: "5", label: "Perfilamiento de Formularios de Salida" },
    { value: "6", label: "DEI - Declaraciones Especiales de Importación" }
  ];

  const orderData = (order) => {
    if (order) {
      let newDirection = "asc";
      
      if (press === order) {
        // Si es la misma columna, cambiar dirección
        newDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        // Nueva columna, ordenar ascendente
        setPress(order);
      }
      
      setSortDirection(newDirection);
      
      // Actualizar URL con los parámetros de ordenamiento
      handleSearchParams({ name: "sortBy", value: order });
      handleSearchParams({ name: "sortDirection", value: newDirection });
      
      // Resetear página a 1 cuando se cambia el ordenamiento
      if (page !== 1) setPage(1);
      
      setUpdate(!update);
    }
  };

  const {
    data: res = {},
    isLoading,
    isError,
    isSuccess,
    isFetching,
  } = useQuery({
    queryKey: ["getNotificationForms", 123, update, page, state?.sortBy, state?.sortDirection],
    queryFn: () =>
      requestData({
        Endpoint: environment.DASHBOARD_GET_NOTIFICATION_FORMS,
        pageParam: page,
        data: {
          qualified_user_id: state?.valueQualified?.length > 0 ? state?.valueQualified?.map((item) => item?.value) : null,
          notification_type: state?.notificationType || null,
          sort_by: state?.sortBy || "expiration_final_date", // Por defecto ordenar por fecha de vencimiento
          sort_direction: state?.sortDirection || "asc", // Por defecto ascendente
        },
        PropertyBody: "sendJSONContentPOST",
      }),
  });

  useEffect(() => {
    if (isSuccess) {
      const newData = res?.data?.status?.data?.data || [];
      
      setData(newData);
      setInitialData(newData);
      setMaxPage(res?.data?.status?.data?.last_page || 1);
      setTotal(res?.data?.status?.data?.total || 0);
      setDataCurrent((prev) => ({
        ...prev,
        itemCurrent: newData,
      }));
      setLinks(res?.data?.status?.data?.links || []);
      
      // Actualizar el estado local con los valores de la URL si existen
      if (state?.sortBy && !press) {
        setPress(state.sortBy);
      }
      if (state?.sortDirection && sortDirection !== state.sortDirection) {
        setSortDirection(state.sortDirection);
      }
    }

    if (isError) {
      openAlert(res?.data?.status?.message || "Error", "error");
    }
  }, [isFetching, isSuccess, isError]);

  // Inicializar ordenamiento por defecto si no hay parámetros en la URL
  useEffect(() => {
    if (!state?.sortBy) {
      handleSearchParams({ name: "sortBy", value: "expiration_final_date" });
      handleSearchParams({ name: "sortDirection", value: "asc" });
    }
  }, []);

  const { isLoading: isLoadingUC, data: dataUC } = useQuery({
    queryKey: [queryEnv.QUALIFIED_USERS, freeZone_id],
    queryFn: () => requestData({
      Endpoint: environment.GET_QUALIFIED_USERS_ALL,
    })
  })

  useEffect(() => {
    if (!isLoadingUC && dataUC?.data?.status?.data) {
      setUserQualified(dataUC?.data?.status?.data || []);
      if (userQualified.length !== dataUC?.data?.status?.data?.length) {
        setUpdate(!update);
      }
    }
  }, [dataUC, isLoadingUC])

  const handleChangeUCOnSearch = (e) => {
    const dataUser = e?.map((user) => ({ value: user?.value, label: user?.label }));
    handleSearchParams({ name: "valueQualified", value: dataUser?.length > 0 ? JSON.stringify(dataUser) : null })
    const setUC = (prev) => ({ ...prev, valueQualified: dataUser })
    /* setLocalValues(setUC); */
    // setValues(setUC);
    if (page !== 1) setPage(1);
    setUpdate(!update);
  }

  const handleChangeUCOnSearchSingle = (e) => {
    handleSearchParams({ name: "valueQualified", value: e?.value ? JSON.stringify({ value: e?.value, label: e?.label }) : null })
    const setUC = (prev) => ({ ...prev, valueQualified: e })
    /* setLocalValues(setUC); */
    // setValues(setUC);
    if (page !== 1) setPage(1);
    setUpdate(!update);
  }

  const handleChangeNotificationType = (e) => {
    handleSearchParams({ name: "notificationType", value: e?.value || null })
    if (page !== 1) setPage(1);
    setUpdate(!update);
  }

  const thead = [
    // { name: "ID", order: "id" },
    { name: "Tipo de notificación", order: "notification_type" },
    // { name: "Tipo de formulario", order: "form_type" },
    { name: "Usuario calificado", order: "qualifiedUser_id" },
    { name: "Formulario", order: "form_code" },
    // { name: "Fecha de inicio", order: "expiration_start_date" },
    // { name: "Fecha de final", order: "expiration_final_date" },
    { name: "Días por vencer", order: "days_until_due" },
    // { name: "Días", order: "days", isNumber: true }
  ];

  const TypeSelector = (type) => {
    const componentMap = {
      first: (
        <InputSelect
          tag={"Usuario calificado"}
          name={"valueQualified"}
          data={!isLoadingUC ? dataUC?.data?.status?.data?.map((item) => ({
            value: item?.id,
            label: item?.nit_qualified + " - " + item?.name_qualified,
            ...item,
          })) : []}
          set={handleChangeUCOnSearchSingle}
          value={state?.valueQualified}
          isLoading={isLoadingUC}
          isDisabled={isLoadingUC}
        />
      ),
      multi: (
        <InputSelectMulti
          className=""
          tag={"Usuario calificado"}
          name={"valueQualified"}
          data={!isLoadingUC ? dataUC?.data?.status?.data?.map((item) => ({
            value: item?.id,
            label: item?.nit_qualified + " - " + item?.name_qualified,
            ...item,
          })) : []}
          set={handleChangeUCOnSearch}
          value={state?.valueQualified}
          isLoading={isLoadingUC}
          isDisabled={isLoadingUC}
        />
      )
    };

    return (
      componentMap[type] || (
        <InputSelect
          tag={"Usuario calificado"}
          name={"valueQualified"}
          data={!isLoadingUC ? dataUC?.data?.status?.data?.map((item) => ({
            value: item?.id,
            label: item?.nit_qualified + " - " + item?.name_qualified,
            ...item,
          })) : []}
          set={handleChangeUCOnSearchSingle}
          value={state?.valueQualified}
          isLoading={isLoadingUC}
          isDisabled={isLoadingUC}
        />
      )
    );
  };

  const getSortIcon = (order) => {
    if (press === order) {
      return sortDirection === "asc" ? 
        <IconGeneric as={MdKeyboardArrowUp} color="#2B6CB0" /> : 
        <IconGeneric as={MdKeyboardArrowDown} color="#2B6CB0" />;
    }
    return <IconGeneric as={BsFilter} color="#CBD5E0" />;
  };

  return (
    <Card w="100%" p={6} mb={6}>
      <Flex gap={4} mb={4} flexWrap="wrap">
        {(!authUser.is_qualified_user || authUser.is_commerce === 1) &&
          !viewFilterQualified && (
            <Box
              w={"300px"}
              minW={"150px"}
            >
              {TypeSelector('multi')}
            </Box>
          )}
        <Box w={"300px"} minW={"150px"}>
          <InputSelect
            tag={"Tipo de notificación"}
            name={"notificationType"}
            data={notificationTypes}
            set={handleChangeNotificationType}
            value={state?.notificationType ? { value: state.notificationType, label: notificationTypes.find(t => t.value == state.notificationType)?.label } : null}
            isLoading={false}
            isDisabled={false}
          />
        </Box>
      </Flex>
      <Text fontSize="2xl" fontWeight="bold" mb={4} textAlign="center">
        Notificaciones
      </Text>
      <div className="table-responsive">
        {isLoading ? (
          <SpinnerComponent />
        ) : (
          <Table size="md" className="table table-lg table-striped">
            <Thead>
              <Tr>
                {thead.map((th, index) => (
                  <ThStyledBlue
                    key={`${th?.name}_${index}`}
                    onClick={() => orderData(th.order)}
                    cursor="pointer"
                    className="text-center"
                    _hover={{ backgroundColor: "#E6FFFA" }}
                  >
                    <div className="d-flex justify-content-center align-items-center mr-4">
                      {th?.name}
                      <span className="ml-2">{getSortIcon(th.order)}</span>
                    </div>
                  </ThStyledBlue>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {data?.length <= 0 && !isLoading ? (
                <Tr>
                  <Td colSpan={thead.length}>No se encontraron datos</Td>
                </Tr>
              ) : (
                data?.map((item, index) => (
                  <Tr
                    key={index}
                    className={""}
                  >
                    {/* <Td className="text-center">{item?.id}</Td> */}
                    <Td className="text-center">{item?.notification_type}</Td>
                    <Td className="text-center">{item?.qualified_user?.name_qualified}</Td>
                    <Td className="text-center">
                      <a
                        href={item?.form_type === "ingreso" ? `/FormShow?FormEntry=${item?.id}` : `FormShowExit?ExitNumber=${item?.id}`}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: '#2B6CB0', textDecoration: 'underline' }}
                      >
                        {item?.form_code}
                      </a>
                    </Td>
                    <Td className="text-center">{item?.days_until_due}</Td>
                  </Tr>
                ))
              )}
            </Tbody>
          </Table>
        )}
        {/* Paginador Chakra UI con números */}
        <Flex justify="center" align="center" mt={4}>
          <ButtonGroup isAttached variant="outline">
            {links?.map((link, idx) => {
              let pageNumber = null;
              if (link.url) {
                const match = link.url.match(/page=(\d+)/);
                pageNumber = match ? Number(match[1]) : null;
              }
              return (
                <Button
                  key={idx}
                  onClick={() => {
                    if (pageNumber) setPage(pageNumber);
                  }}
                  isDisabled={!link.url || link.active}
                  variant={link.active ? "solid" : "outline"}
                >
                  {link.label.replace("&laquo;", "").replace("&raquo;", "")}
                </Button>
              );
            })}
          </ButtonGroup>
        </Flex>
        <Text mt={2} textAlign="center">
          Página {page} de {maxPage} — Total registros: {total}
        </Text>
      </div>
    </Card>
  );
};

export default DashboardSimpleTable;
